import React from 'react'
import {conditionOptionsMap, conditionComponentsMap} from './utils'
import {Button, ctaVariants} from '@/components/ui/button'
import {buttonFunctions, CoreButtonProps, appendSearchParams} from '../utils'
import {cn} from '@/lib/utils'
import type {VariantProps} from 'class-variance-authority'

type ButtonVariantProps = VariantProps<typeof ctaVariants>

export interface ToggleTextButtonProps extends CoreButtonProps {
    condition: string
    conditionMetText: string
    conditionNotMetText: string
    stateToShowInEditor: string
    disabled?: boolean
    variant?: ButtonVariantProps['variant']
    isRevShare?: boolean
    isEdit: boolean
    className?: string
    [key: string]: any // For ...props
}

export const ToggleTextButton = ({
    condition,
    conditionMetText,
    conditionNotMetText,
    stateToShowInEditor,
    disabled,
    variant,
    isRevShare,
    openInNewTab,
    clickFunction = buttonFunctions.linkToPage,
    scrollTargetId,
    queryParams,
    routeType,
    url,
    isEdit,
    className,
    ...props
}: ToggleTextButtonProps) => {
    let ButtonText
    switch (condition) {
        case conditionOptionsMap.ACTIVE_GOAL:
            ButtonText = conditionComponentsMap[conditionOptionsMap.ACTIVE_GOAL]
            break
    }
    const hrefValue = appendSearchParams({
        url,
        queryParamData: queryParams,
        clickFunction,
        scrollTargetId
    })

    const buttonProps = {
        ctaType: 'button' as const,
        disabled,
        variant,
        routeType,
        hrefValue,
        openInNewTab,
        asChild: true,
        className: cn(className, isRevShare && 'rev-share'),
        ...props,
        'data-testid': 'toggleTextButton'
    }

    return (
        <Button {...buttonProps} data-testid={'toggleTextButton'}>
            {ButtonText && (
                <ButtonText
                    conditionMetText={conditionMetText}
                    conditionNotMetText={conditionNotMetText}
                    stateToShowInEditor={stateToShowInEditor}
                    isEdit={isEdit}
                    data-testid="toggleTextButton-ButtonText"
                />
            )}
        </Button>
    )
}
